export default "__VITE_ASSET__40y1BjgK__"